export const environment = {
  base_url:'https://cipla-product-transfer-be-qa.devtomaster.com',
  name:'test',
  production: true
};
